module.exports = __webpack_public_path__ + "public/images/Illustration_Science_200x200-Color.df0836ab81906a0b4f90a81736a015dd.png";